// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"97":"4cca6d4a","108":"dc73dac2","165":"510376f4","184":"4995a3a1","237":"8fa400fe","331":"fc65fb07","639":"e515951b","762":"ab3831f3","835":"c5d40ad7","896":"a393e551"}[chunkId] + ".chunk.js";
};